const StyleConverter = class StyleConverter {
  static createMenuItemTransformation ({ rotation, distanceToCenter }) {
    return { transform: `rotate(${-90 + rotation}deg) translate(${distanceToCenter}px) rotate(${90 - rotation}deg)` }
  }

  static createDropTargetTransformation ({ rotation, skewY }) {
    return { transform: `rotate(${rotation}deg) skewY( ${skewY}deg)` }
  }
}

export default StyleConverter
